import { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((res) => setItems(res.data))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      id="results"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-[#09090B] border-t border-zinc-800"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-[2px] w-12 bg-[#D4AF37]" />
          <p className="font-display text-[#D4AF37] text-sm font-bold tracking-[0.3em] uppercase">
            Client Results
          </p>
        </div>
        <h2
          data-testid="testimonials-heading"
          className="font-display text-white font-black uppercase tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl max-w-4xl mb-14"
        >
          Real people. <span className="text-[#D4AF37]">Real results.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
          {items.map((t) => (
            <figure
              key={t.id}
              data-testid={`testimonial-card-${t.id}`}
              className="relative flex flex-col justify-between bg-zinc-900/50 border border-zinc-800 hover:border-[#D4AF37]/40 p-8 transition-all duration-300 hover:-translate-y-1"
            >
              <div>
                <Quote size={28} strokeWidth={1} className="text-[#D4AF37]/50 mb-5" fill="rgba(212,175,55,0.15)" />
                <blockquote className="text-zinc-300 text-base leading-relaxed font-light">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
              </div>
              <figcaption className="mt-7 pt-5 border-t border-zinc-800">
                <p className="font-display text-white text-lg font-bold uppercase tracking-[0.06em]">
                  {t.name}
                </p>
                <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
                  {t.result && (
                    <span className="font-display text-[#D4AF37] text-sm font-bold uppercase tracking-[0.1em]">
                      {t.result}
                    </span>
                  )}
                  {t.service && (
                    <span className="text-zinc-600 text-[10px] font-semibold tracking-[0.18em] uppercase">
                      {t.service}
                    </span>
                  )}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <a
            href="#contact"
            data-testid="testimonials-cta"
            className="inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#F3CE56] text-zinc-950 px-9 py-4 font-display text-base font-bold uppercase tracking-[0.16em] transition-colors duration-300"
          >
            Your Result Starts Here — Enquire
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
